import InputPhone from 'react-phone-input-2'
import { FC, FocusEventHandler, useMemo, useState } from 'react'
import { InputType } from './forms/Input'
import cn from 'classnames'
import { isValidPhoneNumber } from 'libphonenumber-js'
import ReactCountryFlag from 'react-country-flag'

type PhoneInputType = Omit<InputType, 'value'> & {
  value?: string
}
type CountryData = { countryCode?: string }

const PhoneInput: FC<PhoneInputType> = ({ ...props }) => {
  const [shouldValidate, setShouldValidate] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [iso2, setIso2] = useState('gb')

  const focusHandler: FocusEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (e) => {
    setIsFocused(true)
    props.onFocus?.(e)
  }

  const blur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = (
    e,
  ) => {
    setShouldValidate(true)
    props.onBlur?.(e)
  }

  const isValidNumber = !props.value
    ? !props.required
    : props.value.length <= 3 || isValidPhoneNumber(props.value)

  const countryCodeForFlag = useMemo(() => iso2.toUpperCase(), [iso2])

  return (
    <div
      className={cn(
        'phone-input-wrapper',
        {
          focused: isFocused,
          invalid:
            (shouldValidate || props.touched) &&
            (props.isValid === false || !isValidNumber),
        },
        props.className,
      )}
      style={{ position: 'relative' }}
    >
      <div
        aria-hidden
        className='custom-flag'
        style={{
          alignItems: 'center',
          display: 'flex',
          left: 12,
          pointerEvents: 'none',
          position: 'absolute',
          top: 10,
        }}
      >
        <ReactCountryFlag
          svg
          countryCode={countryCodeForFlag}
          style={{
            height: '16px',
            marginTop: 4,
            width: '16px',
          }}
        />
      </div>

      <InputPhone
        buttonClass='hide-native-flag'
        disabled={props.disabled}
        onFocus={focusHandler}
        inputProps={{
          className: 'form-control',
          id: props.id,
          name: props.name,
        }}
        onBlur={blur}
        country='gb'
        preferredCountries={['gb']}
        specialLabel=''
        value={props.value}
        data-test={(props as any)['data-test']}
        onChange={(v, country: CountryData, _e, formattedValue) => {
          if (country?.countryCode) setIso2(country.countryCode)
          const value = (formattedValue ?? v).replace(/ /g, '') as any
          props.onChange?.(value)
        }}
        onMount={(v, country: CountryData, formattedValue) => {
          if (country?.countryCode) setIso2(country.countryCode)
        }}
      />
    </div>
  )
}

export default PhoneInput
